// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-avatar{display:inline-flex;align-items:center;justify-content:center;width:2rem;height:2rem;font-size:1rem}.p-avatar.p-avatar-image{background-color:transparent}.p-avatar-circle img,.p-avatar.p-avatar-circle{border-radius:50%}.p-avatar .p-avatar-icon{font-size:1rem}.p-avatar img{width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
